import instaclustrComponent from "./Components";

export class Component extends instaclustrComponent {
    constructor(name, node) {
        super(name, node);
    }
    init() {
        console.log(this.name);
    }
}
